import format from 'date-fns/format'

export default class DateTime {
  public date: Date | null = null

  public time: string | null = null

  public seconds: number

  constructor(datetime?: Date | null, date: Date | null = null, time: string | null = null, seconds = 0) {
    this.date = date
    this.time = time
    this.seconds = seconds

    this.initFromDatetime(datetime)
  }

  validate() {
    return this.date !== null
  }

  get datetime() {
    if (this.date !== null) {
      const time = this.time || '00:00'
      const segments = time.split(':').map((item) => parseInt(item))
      const [hours, minutes] = segments
      const datetime = new Date(this.date)

      datetime.setHours(hours, minutes, this.seconds)

      return datetime
    }

    return null
  }

  initFromDatetime(datetime?: Date | null) {
    if (datetime) {
      this.date = datetime
      this.time = format(datetime, 'HH:mm')
      this.seconds = datetime.getSeconds()
    }
  }

  clone() {
    const datetime = new DateTime()

    datetime.date = this.date
    datetime.time = this.time
    datetime.seconds = this.seconds

    return datetime
  }
}
